import { Box, Card, CardContent, Grid, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorIncentives } from "services/vendorDashboard";
import { getDbFormat } from "utils/common";
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import { green } from "@mui/material/colors";

export default function VendorIncentives({pageFilters}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [incentives, setIncentives] = useState(null);

  const getIncentives = useCallback((pageFilters) => {
    const [from, to ]= pageFilters.filterDates;
    const data = {
      from: getDbFormat(from), to: getDbFormat(to), propertyId: pageFilters.library.id, propertyType: 'LIBRARY'
    };
    getVendorIncentives(data).then(({response, error}) => {
      if(response){
        setIncentives(response);
      } else {
        setIncentives([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(pageFilters){
      getIncentives(pageFilters);
    }
  }, [getIncentives, pageFilters]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 2, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate>
        <Grid container columnSpacing={3} rowSpacing={2} >
          {(incentives || []).map((incentive, index) => (
            <Grid item xs={12} sm={6} md={6} xl={3} lg={4} key={index}>
              <Card sx={{height: '100%'}}>
                <CardContent sx={{backgroundColor: '#f8f8f8', height: '100%'}}>
                  <Typography  variant="h6" component="h6" noWrap color={green[600]}>
                   <CurrencyRupeeRoundedIcon sx={{verticalAlign: 'middle', marginLeft: '-6px'}} />{incentive.amount}
                  </Typography>
                  <Typography gutterBottom variant="body2" component="div">
                    {incentive?.description}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {incentive.createdOn}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {incentives?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null}
        </Grid>
      </Box>
    </Paper>
  );
}
